<template>
  <div id="app">
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
    <TheFooter />
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "App",
  created() {
    this.fetchCdtPrices();
  },
  methods: {
    ...mapActions(["fetchCdtPrices"])
  }
};
</script>

<style lang="scss">
* {
  box-sizing: border-box;
}

body {
  margin: 0px;
  font-family: "Lato", sans-serif;
}

h1,
h2,
h3,
h4,
h5,
h6,
p {
  margin: initial;
}

.limit-grid {
  width: 100%;
  margin: 0px auto;
  padding: 0 35px;

  @include media(">=tablet") {
    max-width: 1090px;
  }
}

.limit-grid2 {
  width: 100%;
  margin: 0px auto;
  padding: 0 35px;

  @include media(">=tablet") {
    max-width: 940px;
  }
}

.limit-grid3 {
  width: 100%;
  margin: 0px auto;

  @include media(">large") {
    max-width: 1005;
  }
}

figure {
  margin: 0px;
}
.form {
  &__group {
    &--error {
      position: relative;
      &::before {
        content: url("assets/icons/alert.svg");
        width: 22px;
        height: 22px;
        position: absolute;
        top: calc(50% - 6px);
        right: 8px;
        transform: translateY(-50%);
        display: block;
      }
      select,
      input {
        appearance: none;
        border: 2px solid $color-primary !important;
      }
    }
  }
}
</style>
